import React from 'react';
export function Hero() {
  return <main className="flex-grow flex items-center justify-center bg-[#fafafa] px-4" data-id="element-32">
      <div className="text-center max-w-4xl mx-auto animate-fade-in" data-id="element-33">
        <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-['Playfair_Display',serif] text-[#555555] tracking-tight font-medium" data-id="element-34">
          Prontamente<span className="text-[#CC0000]" data-id="element-35">.</span>
        </h1>
      </div>
    </main>;
}